function combineReducers(reducers) {
  return (state, action) => Object.keys(reducers).reduce((acc, cur) => ({
    ...acc,
    ...reducers[cur](state, action),
  }));
}

export default combineReducers;
